import Client from './client';

export default class RatesNamesSummaries extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getDestinationAndOriginByDestinationAndOrigin(destination, origin, options = {}) {
    return this.makeRequest(`${this.host}/harmonization/rates/names/summaries/destination/${destination}/origin/${origin}`, options);
  }

}
